export type OfferBadgeArm='plain'|'badge';
type ArmStore=Pick<Storage,'getItem'|'setItem'>;
const key='focuscorp_offer_badge_arm_v1';

export function readOfferBadgeArm(store:ArmStore,namespace='live'):OfferBadgeArm|null {
  try { const arm=store.getItem(`${key}:${namespace}`);return arm==='plain'||arm==='badge'?arm:null; }
  catch { return null; }
}

export async function assignOfferBadgeArm(options:{store:ArmStore;readPercent:()=>Promise<number>;random:()=>number;override?:string|null;allowOverride?:boolean;namespace?:string}):Promise<OfferBadgeArm> {
  const namespace=options.namespace??'live';
  try {
    if(options.allowOverride&&(options.override==='plain'||options.override==='badge')){
      options.store.setItem(`${key}:${namespace}`,options.override);return options.override;
    }
    const existing=readOfferBadgeArm(options.store,namespace);
    if(existing)return existing;
    const percent=await options.readPercent();
    const arm:OfferBadgeArm=Number.isInteger(percent)&&percent>=0&&percent<=100&&options.random()<percent/100?'badge':'plain';
    options.store.setItem(`${key}:${namespace}`,arm);
    return arm;
  }catch{return 'plain';}
}

export async function fetchOfferBadgePercent(url:string,anonKey:string,fetcher:typeof fetch=fetch):Promise<number>{
  const endpoint=`${url.replace(/\/$/u,'')}/rest/v1/web_funnel_experiment_config?select=treatment_percent&id=eq.offer_badge`;
  const response=await fetcher(endpoint,{headers:{apikey:anonKey,Authorization:`Bearer ${anonKey}`},cache:'no-store',signal:AbortSignal.timeout(1500)});
  if(!response.ok)throw Error('Offer-badge setting unavailable');
  const rows=await response.json();
  if(!Array.isArray(rows)||rows.length!==1||!Number.isInteger(rows[0]?.treatment_percent))throw Error('Offer-badge setting invalid');
  return rows[0].treatment_percent;
}

export async function fetchLocalOfferBadgePercent(fetcher:typeof fetch=fetch):Promise<number>{
  try{
    const response=await fetcher('http://127.0.0.1:4178/__offer-badge/config',{cache:'no-store',signal:AbortSignal.timeout(500)});
    if(!response.ok)return 50;
    const value=(await response.json()).treatment_percent;
    return Number.isInteger(value)&&value>=0&&value<=100?value:50;
  }catch{return 50;}
}
